export default __webpack_public_path__ + "static/media/knowledge.d57ee6a2.svg";